export default "__VITE_ASSET__Cb9mGk3o__"